import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import ReactStars from "react-stars";
import "./ReviewsCarousel.css";

const ReviewsCarousel = () => {
  const reviewsData = [
    {
      id: 1,
      name: "John Doe",
      review: "Amazing service! I highly recommend them.",
      image: "path/to/john.jpg",
      rating: 5, // 5 stars
    },
    {
      id: 2,
      name: "Jane Smith",
      review: "The results exceeded my expectations. Very professional.",
      image: "path/to/jane.jpg",
      rating: 4.5, // 4.5 stars
    },
    {
      id: 3,
      name: "David Lee",
      review: "Excellent communication and top-notch work.",
      image: "path/to/david.jpg",
      rating: 5, // 5 stars
    },
    {
      id: 4,
      name: "Emily White",
      review: "I was impressed with the attention to detail. Will definitely use again.",
      image: "path/to/emily.jpg",
      rating: 4.5, // 4.5 stars
    },
    {
      id: 5,
      name: "Michael Brown",
      review: "Quick, efficient, and delivered exactly what I needed. Highly satisfied.",
      image: "path/to/michael.jpg",
      rating: 5, // 5 stars
    },
    {
      id: 6,
      name: "Sarah Jones",
      review: "Their expertise was evident from the start. Made the process seamless.",
      image: "path/to/sarah.jpg",
      rating: 4, // 4 stars
    },
    {
      id: 7,
      name: "Kevin Garcia",
      review: "Fantastic experience! They went above and beyond to meet my needs.",
      image: "path/to/kevin.jpg",
      rating: 5, // 5 stars
    },
    {
      id: 8,
      name: "Jessica Rodriguez",
      review: "The quality of their work is outstanding. I'm very pleased with the outcome.",
      image: "path/to/jessica.jpg",
      rating: 5, // 5 stars
    },
    {
      id: 9,
      name: "Christopher Wilson",
      review: "Reliable and trustworthy. They delivered on time and within budget.",
      image: "path/to/christopher.jpg",
      rating: 4.5, // 4.5 stars
    },
    {
      id: 10,
      name: "Amanda Martinez",
      review: "I appreciated their personalized approach. They truly care about their clients.",
      image: "path/to/amanda.jpg",
      rating: 5, // 5 stars
    },
    {
      id: 11,
      name: "Brian Anderson",
      review: "Very helpful and knowledgeable. They answered all my questions promptly.",
      image: "path/to/brian.jpg",
      rating: 4, // 4 stars
    },
    {
      id: 12,
      name: "Nicole Thomas",
      review: "I was nervous at first, but they made me feel comfortable and confident.",
      image: "path/to/nicole.jpg",
      rating: 5, // 5 stars
    },
  ];

  return (
    <section className="reviews-section">
      <div className="reviews-header">
        <h2>Client Success Stories</h2>
        <div className="divider"></div>
        <p>Don't just take our word for it</p>
      </div>

      <div className="reviews-container">
        <div className="reviews-track">
          {[...reviewsData, ...reviewsData].map((review, index) => (
            <div key={`${review.id}-${index}`} className="review-card">
              <FaQuoteLeft className="quote-icon" />
              <p className="review-text">"{review.review}"</p>
              
              <div className="rating-container">
                <ReactStars
                  count={5}
                  value={review.rating}
                  edit={false}
                  size={24}
                  color2={"#00C853"}
                  color1={"#e0e0e0"}
                />
                <span className="rating-value">{review.rating.toFixed(1)}</span>
              </div>

              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  {review.image ? (
                    <img src={review.image} alt={review.name} />
                  ) : (
                    <div className="avatar-placeholder">
                      {review.name.charAt(0)}
                    </div>
                  )}
                </div>
                <div className="reviewer-details">
                  <h4>{review.name}</h4>
                  <p>Verified Client</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

   
    </section>
  );
};

export default ReviewsCarousel;